import axios from "axios";
import { getDateInMMDDYYYYWithOffset } from "../../outboundAmzl/util/Util";
import { getStationCode } from "../../network/NetworkUtil";
import { getAPIGatewayDataFromParent } from "../../handler/ParentDataHandler";
import { logOperationalMetric } from "../../overview/utils/utils";

const metricProcessName = "SCC_OUTBOUND_AR_OVERVIEW_" + getStationCode();

export function fetchOverallStatus(filter, dispatcher, baseUrl) {
  getPackageMetricsFromInduct(filter, dispatcher);
  getPackageMetricsFromStow(filter, dispatcher);
  getPackageMetricsFromRSWS(dispatcher, baseUrl);
}

/** Get Picked/Stage/Departed Count from RSWS **/
async function getPackageMetricsFromRSWS(dispatcher, baseUrl) {
  const startTime = Date.now();
  try {
    const requestPayload = {
      stationCode: getStationCode(),
      date: getDateInMMDDYYYYWithOffset(0),
      metricList: ["PICKED", "STAGED", "DEPARTED", "PROBLEM_SOLVE"],
      groupBy: "NODE",
      filters: {
        cycle: [
          "CYCLE_1", //TODO : read from cycle filter after AMZL launch
        ],
      },
    };
    const api = axios.create({ baseURL: baseUrl });
    const response = await api.post("/rsws/package/metric", requestPayload);
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getRouteInformation",
      true,
    );
    const output = response.data.values;
    dispatcher({ type: "RECEIVE_RSWS_DATA", data: extractRSWSMetrics(output) });
  } catch (error) {
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getRouteInformation",
      false,
    );
  }
}

function extractRSWSMetrics(output) {
  const model = {
    picked: 0,
    staged: 0,
    departed: 0,
    problemSolve: 0,
  };

  output[0].metricList.forEach((dataMetric) => {
    switch (dataMetric.metric) {
      case "PICKED":
        model.picked = dataMetric.metricValue;
        break;
      case "STAGED":
        model.staged = dataMetric.metricValue;
        break;
      case "DEPARTED":
        model.departed = dataMetric.metricValue;
        break;
      case "PROBLEM_SOLVE":
        model.problemSolve = dataMetric.metricValue;
        break;
      default:
        break;
    }
  });
  return model;
}

/** Get Inducted Count from IVS **/
async function getPackageMetricsFromInduct(filter, dispatcher) {
  const startTime = Date.now();
  try {
    const cycleIds =
      filter.selectedCycles.length === 0
        ? filter.allCycles.map((cycle) => cycle.cycleName)
        : filter.selectedCycles;
    let filterMap = {
      Cycle: cycleIds,
    };
    const request = {
      nodeId: getStationCode(),
      groupBy: "Node",
      filters: filterMap,
      metricList: ["INDUCTED_AT_STATION"],
    };
    const args = getInductAPIGatewayRequest(request);
    getAPIGatewayDataFromParent(args).then((result) => {
      if (result.status === 200) {
        logOperationalMetric(
          startTime,
          metricProcessName,
          "getPackageMetricsFromInduct",
          true,
        );
        const output = result.data.groupedPackageMetrics;
        const stationCode = getStationCode();
        dispatcher({
          type: "RECEIVE_INDUCT_DATA",
          data: { inducted: output.INDUCTED_AT_STATION[stationCode] },
        });
      } else {
        logOperationalMetric(
          startTime,
          metricProcessName,
          "getPackageMetricsFromInduct",
          false,
        );
      }
    });
  } catch (e) {
    logOperationalMetric(
      startTime,
      metricProcessName,
      "getPackageMetricsFromInduct",
      false,
    );
  }
}

function getInductAPIGatewayRequest(request) {
  return {
    resourcePath: "/ivs/getPackageMetric",
    httpMethod: "post",
    processName: "induct",
    requestBody: request,
  };
}

/** Get Stowed Count from SVS **/
async function getPackageMetricsFromStow(filter, dispatcher) {
  try {
    let requestFilter;
    if (filter && filter.selectedCycles.length > 0) {
      requestFilter = {
        NODE: [getStationCode()],
        CYCLE: filter.selectedCycles,
      };
    } else {
      requestFilter = {
        NODE: [getStationCode()],
      };
    }
    const request = {
      filters: requestFilter,
      groupBy: "NODE",
      metrics: ["CURRENT_STOWED_COUNT"],
    };
    getStowMetrics(dispatcher, request);
  } catch (e) {}
}

function getStowAPIGatewayRequest(request) {
  return {
    resourcePath: "svs/packages/metrics",
    httpMethod: "post",
    processName: "stow",
    requestBody: request,
  };
}

async function getStowMetrics(dispatcher, request) {
  const startTime = Date.now();
  const args = getStowAPIGatewayRequest(request);
  getAPIGatewayDataFromParent(args).then((result) => {
    if (result.status === 200) {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getStowMetrics",
        true,
      );
      const output = result.data.groupedPackageMetrics;
      const stationCode = getStationCode();
      dispatcher({
        type: "RECEIVE_STOW_DATA",
        data: {
          stowed: output[stationCode]
            ? output[stationCode].currentStowedCount
            : 0,
        },
      });
    } else {
      logOperationalMetric(
        startTime,
        metricProcessName,
        "getStowMetrics",
        false,
      );
    }
  });
}



// WEBPACK FOOTER //
// ./src/components/overallstatus/network/OverallStatusNetworkAPI.js